{
  "states": {
    "loading": "Ana lodi...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "San Francisco"
  },
  "conditions": {
    "Clear": "Sararin sama",
    "Clouds": "Gizagizai",
    "Rain": "Ruwan sama",
    "Drizzle": "Yayyafi",
    "Thunderstorm": "Hadari mai tsawa",
    "Snow": "Dusar ƙanƙara",
    "Mist": "Hazo",
    "Smoke": "Hayaƙi",
    "Haze": "Hazo mai sirara",
    "Dust": "Ƙura",
    "Fog": "Hazo mai kauri",
    "Sand": "Yashi",
    "Ash": "Toka",
    "Squall": "Guguwa",
    "Tornado": "Guguwar iska"
  },
  "modal": {
    "defaultTitle": "Yanayi",
    "subtitle": "Yanayin yanzu",
    "showFahrenheit_aria": "Nuna Fahrenheit",
    "showCelsius_aria": "Nuna Celsius",
    "switchToCelsius_title": "Canza zuwa °C",
    "switchToFahrenheit_title": "Canza zuwa °F",
    "feelsLike": "Yana kama da {{temp}}°{{unit}}",
    "humidityWind": "Danshi {{humidity}}% · Iska {{wind}}",
    "windSpeed": "{{speed}} mph",
    "hourlyNow": "Yanzu",
    "hourlyOffset": "{{hours}}h",
    "hourlyStrip_aria": "Zafin jiki na sa'a-sa'a",
    "hourlyLocked": "Hasashen sa'a-sa'a fasalin Pro ne.",
    "statsLocked": "Bayanan yanayi fasalin Pro ne.",
    "stats": {
      "sunrise": "Fitar rana",
      "sunset": "Faɗuwar rana",
      "feels": "Yana kama",
      "humidity": "Danshi",
      "wind": "Iska",
      "rain": "Ruwan sama"
    },
    "rainInches": "{{value}} in",
    "forecastTitle": "Hasashen Kwana 5",
    "forecastLoading": "Ana lodin hasashe…",
    "forecastUnavailable": "Hasashe babu",
    "forecastLocked": "Hasashen kwana 5 fasalin Pro ne.",
    "forecastRow_aria": "Hasashen kwana biyar",
    "proHeadline": "Cikakken hasashen yanayi yana cikin Pro.",
    "proFeatures": "Kowace awa · Cikakkun yanayi · Hasashen kwana 5."
  }
}
